module.exports = __webpack_public_path__ + "static/media/parking.88194bb5.jpg";